import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1a7f07dc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f07dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a7f07dc')) {
      api.createRecord('1a7f07dc', component.options)
    } else {
      api.reload('1a7f07dc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1a7f07dc&scoped=true&", function () {
      api.rerender('1a7f07dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24K9VcD1MHU5H/JS/comp/SearchFilterTokens.vue"
export default component.exports